import { PersonListItemCompanyType } from '@api';
import { AddressCell, EmailAnchor, PhoneNumberAnchor } from '@common';
import { DataTableColumn } from 'mantine-datatable';
import { useTranslation } from 'react-i18next';

type UsePersonsOverviewSubtableColumnsReturnType = {
  columns: DataTableColumn<PersonListItemCompanyType>[];
};

export const usePersonsOverviewSubtableColumns =
  (): UsePersonsOverviewSubtableColumnsReturnType => {
    const { t } = useTranslation('persons');

    const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    const columns: DataTableColumn<PersonListItemCompanyType>[] = [
      {
        accessor: 'title',
        render: (record) => {
          switch (record.type) {
            case 'PRIVATE':
              return t('TABLE.SUBTABLE.TITLE_PRIVATE');
            case 'BUSINESS':
              return `${t('TABLE.SUBTABLE.TITLE_BUSINESS_PREFIX')} ${record.companyName || noDataPlaceholder}`;
            default:
              return noDataPlaceholder;
          }
        },
        width: 350,
      },
      {
        accessor: 'contact.phone',
        render: (record) =>
          record.contact.phone ? (
            <PhoneNumberAnchor phoneNumber={record.contact.phone} />
          ) : (
            noDataPlaceholder
          ),
        width: 150,
      },
      {
        accessor: 'contact.mobile',
        render: (record) =>
          record.contact.mobile ? (
            <PhoneNumberAnchor phoneNumber={record.contact.mobile} />
          ) : (
            noDataPlaceholder
          ),
        width: 150,
      },
      {
        accessor: 'contact.email',
        render: (record) =>
          record.contact.email ? (
            <EmailAnchor email={record.contact.email} />
          ) : (
            noDataPlaceholder
          ),
        width: 300,
      },
      {
        accessor: 'address',
        render: (record) => <AddressCell address={record.address} />,
        width: 400,
      },
    ];

    return { columns };
  };
